import { render, staticRenderFns } from "./bf-button.vue?vue&type=template&id=5d43cd53&"
import script from "./bf-button.vue?vue&type=script&lang=js&"
export * from "./bf-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports